import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { replaceHashValues } from "utils/replaceHashValues";
import { media } from "utils/style";
import Button from "common-components/Buttons";
import { isUnregistered } from "utils/isUnregistered";

const DownloadReady = ({
  pageContent,
  renderCategoryList,
  downloadAvailabilityDeadline,
  showConfirmationModal,
  handleDownloadFileClick,
  dateOfRequest,
  resendPasswordClick,
  handleRequestHistoryClick,
  dateRangeLabel,
  ...props
}) => (
  <Fragment>
    <Header style={{ marginBottom: "16px" }}>{pageContent.section_title}</Header>
    <Div>
      <div>
        {convertStringToElements(
          replaceHashValues(pageContent.section_description, {
            requestDate: dateOfRequest,
            dateRangeSelected: dateRangeLabel
          })
        )}
      </div>
      {renderCategoryList()}
      <SubDiv>
        {convertStringToElements(
          replaceHashValues(pageContent.Category[0].category_sub_description, {
            downloadAvailabilityDeadline: downloadAvailabilityDeadline
          })
        )}
      </SubDiv>
      {isUnregistered() ?
        <RequestHistoryButton>
          <span onClick={handleRequestHistoryClick}>{pageContent.buttons[1].text}</span>
        </RequestHistoryButton>
        : null}
    </Div>

    <Button onClick={handleDownloadFileClick} background={pageContent.buttons[0].type}>
      {pageContent.buttons[0].text}
    </Button>
    {/* {isUnregistered() ? null : (
      <Button onClick={() => showConfirmationModal("delete")} background={pageContent.buttons[1].type}>
        {pageContent.buttons[1].text}
      </Button>
    )} */}
    {/* <p style={{ marginTop: "45px" }}>
      {pageContent.links[0].desc}
      <ResendPasswordButton onClick={resendPasswordClick}>{pageContent.links[0].text}</ResendPasswordButton>
    </p> */}
  </Fragment>

);

DownloadReady.propTypes = {
  pageContent: PropTypes.object.isRequired,
  renderCategoryList: PropTypes.func.isRequired,
  downloadAvailabilityDeadline: PropTypes.string.isRequired,
  showConfirmationModal: PropTypes.func.isRequired,
  handleDownloadFileClick: PropTypes.func.isRequired,
  resendPasswordClick: PropTypes.func.isRequired,
  dateOfRequest: PropTypes.string.isRequired,
  dateRangeLabel: PropTypes.string.isRequired
};

export default DownloadReady;



const Div = styled.div`
  margin-bottom: 48px;

  p,strong{
    font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 300;
    line-height: 36px; /* 112.5% */
    letter-spacing: 0.25px;
  }
  ul {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
    margin: 15px 0;
  }
  li{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  }
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
    margin: 15px 0;
  }
  
  p:first-of-type {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 32px;
    color: #6F7171;
  }
`;

const SubDiv = styled.div`
p,strong{
  font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px; /* 112.5% */
  letter-spacing: 0.25px;
 }

p {
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin: 15px 0;
}

p:first-of-type {
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin: 15px 0;
  color:#000
}
`;

const ResendPasswordButton = styled.button`
  background: 0;
  border: 0;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  display: block;

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;
const RequestHistoryButton = styled.div`
span {
    background: transparent;
    border: none;
    text-decoration: underline;
    font-size: 16px;
    line-height: 20px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-weight: 400;
    cursor: pointer;
  }
`;

const Header = styled.h1`
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;
